import React, { lazy } from 'react';
function GoldenParticles() {
  const particles = Array.from({
    length: 8
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-[2] hidden sm:block" data-id="element-199">
      {particles.map((_, i) => {
      const left = `${Math.random() * 100}%`;
      const delay = `${Math.random() * 5}s`;
      const duration = `${8 + Math.random() * 7}s`;
      const size = Math.random() > 0.5 ? 'w-1 h-1' : 'w-1.5 h-1.5';
      return <div key={i} className={`absolute bottom-0 rounded-full bg-gold/60 ${size}`} style={{
        left,
        animation: `particleFloat ${duration} linear ${delay} infinite`
      }} data-id="element-200" />;
    })}
    </div>;
}
export function HeroSection() {
  return <section className="relative px-4 sm:px-[5%] py-16 sm:py-24 flex flex-col items-center text-center overflow-hidden min-h-[75vh] sm:min-h-[85vh] justify-center" role="banner" data-id="element-201">
      <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Simbolo_dorado_infinito_en_el_vacio_06918f45-889b-4991-b0b4-6e1b82309461.png?v=1777332793" alt="" aria-hidden="true" loading="eager" decoding="async" fetchPriority="high" sizes="100vw" width="1920" height="1080" className="absolute inset-0 w-full h-full object-cover object-[center_20%] sm:object-center opacity-35 z-0 pointer-events-none" data-id="element-202" />

      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-transparent to-[#0A0A0B] z-[1]" aria-hidden="true" data-id="element-203" />

      <GoldenParticles data-id="element-204" />

      <div className="relative z-10 max-w-4xl animate-fadeInUp flex flex-col items-center gap-0" data-id="element-205">
        <div className="relative w-full flex justify-center mb-6 sm:mb-10" data-id="element-206">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] sm:w-[600px] h-[150px] sm:h-[200px] bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.15),transparent_70%)] blur-3xl z-[5] pointer-events-none" style={{
          animation: 'pulseGlow 4s ease-in-out infinite'
        }} data-id="element-207" />
          <h1 className="font-serif text-[24px] sm:text-4xl md:text-5xl leading-[1.2] font-black max-w-4xl relative z-10" data-id="element-208">
            No es falta de esfuerzo.
            <br data-id="element-209" />
            <span className="text-gold" data-id="element-210">
              Es un patrón interno que está afectando tu claridad, tu energía y
              tus decisiones.
            </span>
          </h1>
        </div>

        <div className="text-sm sm:text-lg opacity-90 leading-relaxed mb-2 max-w-2xl mx-auto font-medium px-2 sm:px-0 relative z-10" data-id="element-211">
          <p data-id="element-212">
            El Código 888 es un sistema diseñado para ayudarte a ordenar
            tu mente, reconocer patrones internos y empezar a pensar, decidir y
            actuar con más claridad.
          </p>
        </div>

        <p className="text-white/70 text-xs sm:text-base mb-8 sm:mb-12 font-medium relative z-10" data-id="element-213">
          No es teoría. No es motivación vacía. Es un proceso de
          transformación interna.
        </p>

        <div className="flex flex-col items-center w-full relative z-10" data-id="element-214">
          <button onClick={() => {
          document.getElementById('personaliza')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-gold text-dark min-h-[48px] py-3.5 sm:py-4 px-6 sm:px-12 text-sm sm:text-lg font-black rounded-xl shadow-[0_15px_40px_rgba(212,175,55,0.35)] hover:shadow-[0_20px_50px_rgba(212,175,55,0.5)] hover:bg-yellow-400 active:scale-[0.97] transition-all duration-300 w-full max-w-[300px] sm:max-w-md" data-id="element-215">
            ACTIVAR EL CODIGO 888
          </button>

          <p className="text-white/60 text-xs sm:text-sm mt-5 sm:mt-6 tracking-wide" data-id="element-216">
            💳Pago único · ⚡Acceso inmediato · 🔓Sin suscripciones
          </p>
        </div>
      </div>
    </section>;
}